<style lang="scss" scoped>
.sidebar {
    width: 200px;
    position: absolute !important;
    top: 108px;
    bottom: 0;
    left: 0;
    overflow: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;
    background-color: #f3f3f3;
    border-right: 1px solid #d0d0d0;
    .folder {
        padding: 10px 0;
        .icon-add-plus,.icon-setting-small {
            float: right;
            margin-top: 10px;
        }
        .icon-more-big,
        .icon-more-right-big {
            float: left;
            margin: 10px 6px 0 -12px;
        }
        .clear-file{
            float: right;
        }
    }
    .folder-list {
        padding: 10px 0 0;
        &:last-child {
            padding-top: 0;
        }
        .other {
            height: auto;
        }
    }
    li {
        padding: 0 19px;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        color: #505060;
        // overflow: hidden;
        // text-overflow: ellipsis;
        cursor: pointer;
        &:hover:not(.other),
        &.active {
            color: #0178d7;
            background-color: #d0d0d0;
        }
        .name {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            white-space: nowrap;
            vertical-align: middle;
        }
    }
    .other-list {
        li {
            padding-right: 42px;
            // overflow: hidden;
            // text-overflow:ellipsis;
            white-space: nowrap;
        }
    }
    .bt {
        border-top: 1px solid #d0d0d0;
    }
    #writeBtn {
        font-weight: 600;
        color: #000;
        padding: 0 19px;
        display: block;
        height: 30px;
        width: 100%;
        line-height: 30px;
        cursor: pointer;
        font-size: 14px;
        .icon-pen {
            width: 12px;
        }
    }
}
</style>

<template>
    <div class="sidebar" v-bar scroll="no">
        <div>

            <ul class="folder">
                <router-link :to="{name: 'write'}" class="bzb" id="writeBtn">
                    <img src="@/assets/image/pen.png" alt="" class="icon-pen"> 写邮件
                </router-link>
                <router-link :to="{name: 'unread'}" tag="li">
                    <span>未读邮件</span>
                    <span v-if="mailFolders.unread&&mailFolders.unread.unread">({{mailFolders.unread.unread}})</span>
                </router-link>
                <router-link :to="{name: 'recv'}" tag="li">
                    <span>收件箱</span>
                    <span v-if="mailFolders.recv&&mailFolders.recv.unread">({{mailFolders.recv.unread}})</span>
                </router-link>
                <router-link :to="{name: 'draft'}" tag="li">
                    <span>草稿箱</span>
                </router-link>
                <router-link :to="{name: 'send'}" tag="li">
                    <span>已发送</span>
                    <span v-if="mailFolders.send&&mailFolders.send.unread">({{mailFolders.send.unread}})</span>
                </router-link>
                <router-link :to="{name: 'deleted'}" tag="li">
                    <span>已删除</span>
                    <span v-if="mailFolders.deleted&&mailFolders.deleted.unread">({{mailFolders.deleted.unread}})</span>
                    <span class="clear-file" @click="clearFolder(mailFolders.deleted)">【清空】</span>
                </router-link>
                <router-link :to="{name: 'spam'}" tag="li">
                    <span>垃圾邮件</span>
                    <span v-if="mailFolders.spam&&mailFolders.spam.unread">({{mailFolders.spam.unread}})</span>
                    <span class="clear-file" @click="clearFolder(mailFolders.spam)">【清空】</span>                    
                </router-link>
            </ul>
            <ul class="folder bt">
                <!-- <router-link :to="{name: 'gtasks'}" tag="li">
            <span>待办邮件</span> -->
                <!-- <span v-if=mailFolders.gtasks.unread>(mailFolders.gtasks.unread)</span> -->
                <!-- </router-link> -->
                <router-link :to="{name: 'star'}" tag="li">
                    <span>星标邮件</span>
                </router-link>
                <router-link :to="{name: 'important'}" tag="li">
                    <span>重要联系人邮件</span>
                </router-link>
            </ul>
            <ul class="folder folder-list bt">
                <li class="other">
                    <div class="" @click="toggleFolder('multiShow')">
                        <span class="icons" :class="multiShow?'icon-more-big':'icon-more-right-big'"></span>
                        <span>一箱多邮</span>
                        <router-link :to="{name:'settingPop'}"> 
                            <span class="icons icon-setting-small" @click.stop v-tooltip.top="{content: '点击设置', delay: {show: 500}}"></span> 
                        </router-link>                      
                    </div>
                    <ul class="other-list" v-if="multiShow">
                        <router-link :to="{name: 'multi',params:{folderId:item.folder_id}}" tag="li" v-for="(item,key) in mailFolders.multiMails" :key=key v-tooltip.top-start="{content: item.name, delay: {show: 500}}">
                            <span class="name">{{item.name}}</span>
                            <template v-if="item.unread">({{item.unread}})</template>
                        </router-link>
                    </ul>
                </li>
            </ul>
            <ul class="folder folder-list">
                <li class="other">
                    <div class="" @click="toggleFolder('otherShow')">
                        <span class="icons" :class="otherShow?'icon-more-big':'icon-more-right-big'"></span>
                        <span>其他文件夹</span>
                        <span class="icons icon-add-plus" @click.stop="addFolder" v-tooltip.top="{content: '点击添加', delay: {show: 500}}"></span>
                    </div>
                    <ul class="other-list" v-if="otherShow">
                        <router-link :to="{name: 'other',params:{folderId:item.folder_id}}" tag="li" v-for="(item,key) in mailFolders.other" :key=key v-tooltip.top-start="{content: item.name, delay: {show: 500}}">
                            <span class="name">{{item.name}}</span>
                            <template v-if="item.unread">({{item.unread}})</template>
                        </router-link>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { sortFolders, createOtherFolder, deleteOtherFolder, renameOtherFolder, sysMailCheck, clearAll } from '@/service/folderService'
import { mapState, mapActions } from 'vuex'
import utils from '@/common/utils'
export default {
    name: 'mailSidebar',
    data() {
        return {
            t: 0,
            i: 0,
            otherShow: false,
            multiShow: false,
        }
    },
    computed: {
        ...mapState([
            'mailFolders'
        ]),
    },
    created() {
        this.getFolders()
        this.sysMailPolling()
        this.otherShow = utils.getLocalStorage('otherShow') == 'true'
        this.multiShow = utils.getLocalStorage('multiShow') == 'true'
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        ...mapActions([
            'getFolders'
        ]),
        sysMailPolling() {
            this.timer = setInterval(() => {
                sysMailCheck({ i: this.i, t: this.t }).then((res) => {
                    var status = res.status;
                    if (status == 200) {
                        var data = res.data,
                            newmail = data.newmail
                        this.t = data.t
                        this.i = data.i
                        if (newmail != 0) {
                            this.getFolders()
                            this.$emit('updateCB')                            
                        }
                    }
                })
            }, 1000 * 30); //30s
        },
        toggleFolder(type) {
            this[type] = !this[type]
            utils.setLocalStorage(type, this[type])
        },
        addFolder() {
            this.$addfolder({
                show: true,
                cb: () => { this.getFolders() }
            })
        },
        clearFolder(item){
            this.$confirm({
                title:'清空文件夹',
                message:`您确定要清空“${item.name}”文件夹的所有邮件吗？`,
                onSure:()=>{
                    clearAll(item.folder_id).then((res)=>{
                        if(res.status==200){
                            this.$toast({
                                message: '邮件已清空',
                                theme: 'success'
                            })
                            this.getFolders()
                            this.$emit('updateCB')                        
                        }else{
                            this.$toast({
                                message: '邮件清空失败',
                                theme: 'danger'
                            })
                        }
                    })
                }
            })
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/components/sidebar/mail.vue